import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordUpdateFormComponent } from './password-update-form/password-update-form.component';
import { PasswordUpdateComponent } from './password-update.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputModule } from '../../../settings-v2/components/input/input.module';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { InputPasswordModule } from '../../../settings-v2/components/input-password/input-password.module';
import { RouterModule } from '@angular/router';
import { StandardAlertModule } from '../../../annuities/shared/standard-alert/standard-alert.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputModule,
    InputPasswordModule,
    TooltipModule,
    ButtonModule,
    RouterModule,
    StandardAlertModule,
  ],
  declarations: [PasswordUpdateComponent, PasswordUpdateFormComponent],
  exports: [PasswordUpdateComponent, PasswordUpdateFormComponent]
})
export class PasswordUpdateModule {
}
